import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import style from './reject-banner.module.less';
import { RejectionReasonEnum } from '../../enums/rejection-reason-values';
import Global from '../../store/global-selectors';

const RejectedBanner = ({ className = '', fulfillmentPlanId }) => {
  const isRejectedFulfillment = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanIsRejected(state, {
      fulfillmentPlanId,
    }),
  );
  const fulfillmentProviders = useSelector(Global.selectSellerActiveFulfillmentProviders);
  const sellerFulfillmentProviderId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSellerFulfillmentProviderID(state, {
      fulfillmentPlanId,
    }),
  );
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByFulfillmentPlanId(state, {
      fulfillmentPlanId,
    }),
  );

  if (!isRejectedFulfillment) {
    return null;
  }

  const [mostRecentFulfillment] = fulfillments.sort((a, b) => {
    return new Date(b.createDateTime) - new Date(a.createDateTime);
  });
  const rejectionReasonKey = mostRecentFulfillment?.externalFulfillmentError;
  const rejectionReason = <FormattedMessage {...RejectionReasonEnum[rejectionReasonKey]?.messageDescriptor} />;

  const fulfillmentProvider = fulfillmentProviders.find((provider) => provider.sellerFulfillmentProviderId === sellerFulfillmentProviderId);
  const fulfillmentProviderName = fulfillmentProvider ? fulfillmentProvider.name : null;

  return (
    <BannerMessageV2
      className={className}
      content={
        <>
          <h4 className={style['rejected-banner__title']}>
            {fulfillmentProvider ? (
              <FormattedMessage
                defaultMessage='Rejected By {fulfillmentProviderName}'
                description='Message informing user the name of the fulfillment provider that rejected their fulfillment'
                id='/wTQFT'
                values={{ fulfillmentProviderName }}
              />
            ) : (
              <FormattedMessage
                defaultMessage='Rejected By Fulfillment Provider'
                description='Message informing user that their fulfillment was rejected without a Provider Name'
                id='Pg1+VV'
              />
            )}
          </h4>
          {rejectionReasonKey && RejectionReasonEnum[rejectionReasonKey] ? (
            <p className={style['rejected-banner__help-text']}>
              <FormattedMessage
                defaultMessage='Provider Reason: {rejectionReason}'
                description='Message informing the user as to why a fulfillment was rejected with a message given by the service provider'
                id='4lldPl'
                values={{
                  rejectionReason,
                }}
              />
            </p>
          ) : null}
          <p className={style['rejected-banner__help-text']}>
            <FormattedMessage
              defaultMessage='You can Restore, Hold, Cancel, or fulfill another way.'
              description='Message informing the user of what actions he or she can take with this fulfillment that has been rejected'
              id='I8qe39'
            />
          </p>
        </>
      }
      status={BannerStatus.Info}
    />
  );
};

RejectedBanner.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default RejectedBanner;
